import { unformat, format } from '@react-input/mask';

export const maskConfig = {
  mask: '+7 (___) ___-__-__',
  replacement: { _: /\d/ },
};

export const unmask = (phone: string) => '7' + unformat(phone, maskConfig);
export const mask = (phone: string) =>
  format(phone.substring(1, 11), maskConfig);
